import React, { useContext } from 'react'
import Title from '../../common/Title'
import { useIntl } from 'react-intl'
import { Button, Dropdown } from 'ui'
import { AccountStatementContext } from '../context/AccountStatementContext'

export const TittleBanner = ({
   setIsTryOnModalOpen,
   setIsEmailModalOpen
}: {
   setIsTryOnModalOpen: React.Dispatch<React.SetStateAction<boolean>>
   setIsEmailModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}) => {
   const intl = useIntl()
   const { image, loyaltyPlanId, member, programs, setLoyaltyPlanId, setImage } = useContext(AccountStatementContext)
   const planLoyalty = programs?.find((program) => {
      return typeof loyaltyPlanId === 'string' ? program.id === parseInt(loyaltyPlanId) : program.id === loyaltyPlanId
   })?.name
   const handleSetLoyaltyPlanId = (id: string) => {
      if (id !== loyaltyPlanId) {
         if (image && image.path) {
            setImage(null)
         }
      }
      setLoyaltyPlanId(id)
   }
   return (
      <Title
         className="flex justify-between gap-x-2  items-center "
         value={intl.formatMessage({ id: 'settings.tittle' })}
      >
         <div className='flex gap-x-2 items-center'>
            <Dropdown className="">
               <Dropdown.Toggle className="cursor-pointer flex w-full items-center justify-between rounded-md bg-white px-3 py-2 text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 whitespace-nowrap">
                  {intl.formatMessage({ id: 'settings.form.loyaltyPlanId' })}: {planLoyalty}
               </Dropdown.Toggle>
               <Dropdown.Menu>
                  {({ onToggle }) => <ul>
                     {programs?.filter(i => i.isActive).map((option) => {
                        if (!option.hasPointBenefit) {
                           return null
                        }
                        return (
                           <li
                              key={option.id}
                              className="hover:bg-gray-100 focus:outline-none cursor-pointer block  whitespace-nowrap font-light p-2"
                              onClick={({ currentTarget }) => {
                                 handleSetLoyaltyPlanId(option.id)
                                 onToggle(false)
                              }}
                           >
                              {option.name}
                           </li>
                        )
                     })}
                  </ul>}
               </Dropdown.Menu>
            </Dropdown>
            <Button onClick={() => { setIsTryOnModalOpen(true) }} className={'flex gap-x-2 items-center text-[12px] mr-4 '}>
               {intl.formatMessage({ id: 'settings.tryon' })}
            </Button>
            <Button onClick={() => setIsEmailModalOpen(true)}
               disabled={!loyaltyPlanId || !member?.id}
               className={'flex gap-x-2 items-center text-[12px] mr-4 '}>
               {intl.formatMessage({ id: 'settings.send.tryon' })}
            </Button>
         </div>
      </Title>


   )
}

